/* eslint-disable import/no-anonymous-default-export */
import { WorkReportDetailList } from './WorkReportDetailList';

export default {
    list: WorkReportDetailList,
};
